import React from "react";
import { Popover } from "@headlessui/react";
import Button from "../Button";
import { DocumentRemoveIcon } from "@heroicons/react/outline";
import tableIcons from "./MaterialTableIcons";
import { TablePagination } from "@material-ui/core";
import CustomLoader from "../CustomLoader";
import MaterialTable, { MTableToolbar } from "material-table";

const PatchedPagination = ({
  ActionsComponent,
  onChangePage,
  onChangeRowsPerPage,
  ...tablePaginationProps
}) => {
  return (
    <TablePagination
      {...tablePaginationProps}
      // @ts-expect-error onChangePage was renamed to onPageChange
      onPageChange={onChangePage}
      SelectProps={{
        IconComponent: () => <div></div>,
      }}
      onRowsPerPageChange={onChangeRowsPerPage}
      ActionsComponent={(subprops) => {
        const { onPageChange, ...actionsComponentProps } = subprops;
        return (
          // @ts-expect-error ActionsComponent is provided by material-table
          <ActionsComponent
            {...actionsComponentProps}
            onChangePage={onPageChange}
          />
        );
      }}
    />
  );
};
const MaterialSubTable = ({
  columns,
  data = [],
  toolbar,
  showTitle = false,
  showToolBar,
  title,
  exportButton,
  grouping,
  search = false,
  detailPanel,
  style = {
    backgroundColor: "#FFFFFF",
    color: "#260B08",
    fontSize: "12px",
  },
  selection,
  selectedRows = [],
  onSelectionChange,
  setOpenModal,
  isDeactivate,
  toolBarComponent,
  isActive = true,
  paging = false,
  pageSize = 2,
  searchFieldAlignment,
  loading = true,
  headerStyle = {
    backgroundColor: "#FFFFFF",
    color: "black",
    fontWeight: "bold",
    fontSize: "13px",
  },
  header,
  tableRef,
  onSearchChange,
  defaultExpanded = false,
}) => {
  return (
    <div>
      <MaterialTable
        columns={columns}
        data={data}
        tableRef={tableRef}
        style={style}
        title={
          title ? (
            title
          ) : (
            <div>
              <div className="text-secondary italic text-xs3 my-4 px-4">
                <p className="font-bold italic inline-block mr-1">Note: </p>
                Tick the box to deactivate some data.
              </div>
              {/* <div className="border-b-4 border-red-500"></div> */}
              {selectedRows.length > 0 ? (
                <Popover className="my-4 mb-1  rounded-lg  ">
                  <div className="flex justify-start mx-2 mt-2">
                    <Button
                      className="hover:scale-90 transition duration-500  bg-secondary hover:bg-hsecondary border-secondary hover:border-hsecondary rounded-2xl focus:ring-secondary w-24 "
                      onClickFunction={() => {
                        setOpenModal(true);
                      }}
                    >
                      <DocumentRemoveIcon className="h-4 w-4 -ml-1 mr-1 " />{" "}
                      {isDeactivate ? "Deactivate" : "Delete"}
                    </Button>
                    <div className="mt-1 ml-2 text-xs text-primary text-medium ">
                      {isDeactivate ? "Deactivate" : "Delete"} Selected Row/s
                      <p className="inline-block font-bold">
                        &nbsp;({selectedRows.length})
                      </p>
                    </div>
                  </div>
                </Popover>
              ) : (
                ""
              )}
            </div>
          )
        }
        onSearchChange={onSearchChange}
        localization={{
          body: {
            emptyDataSourceMessage: loading ? (
              <CustomLoader />
            ) : (
              <label
                style={{
                  position: "absolute",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  fontSize: "14px",
                }}
              >
                No records to display.
              </label>
            ),
          },
        }}
        defaultExpanded={defaultExpanded}
        options={{
          toolbar: toolbar,
          header: header,
          showTitle: showTitle,
          exportButton: exportButton,
          searchFieldAlignment: searchFieldAlignment,
          pageSize: pageSize,
          pageSizeOptions: [10, 15, 20, 25, 30, 100],
          grouping: grouping,
          defaultExpanded: defaultExpanded,
          detailPanelColumnStyle: { width: 50 },
          search: search,
          headerStyle: headerStyle,
          rowStyle: (rowData) => ({
            backgroundColor: "#F8F8F8",
            color: "#21BBEF",
            fontWeight: "bold",
            fontSize: "13px",
          }),
          tableLayout: "auto",
          selection: selection,
          loadingType: "overlay",
          showTextRowsSelected: false,
          selectionProps: isActive
            ? (rowData) => {
                const checked = !rowData.isActive ? { checked: false } : {};
                return {
                  disabled:
                    !rowData.isActive || rowData.isActive === "Inactive",
                  ...checked,
                };
              }
            : (rowData) => {
                const checked = !rowData.status ? { checked: false } : {};
                return {
                  disabled: !rowData.status,
                  ...checked,
                };
              },
          paging: paging,
        }}
        onSelectionChange={(rows) =>
          onSelectionChange(
            rows.map((r) => {
              const { tableData, ...rows } = r;
              return rows;
            })
          )
        }
        icons={tableIcons}
        detailPanel={detailPanel}
        isLoading={loading}
        components={{
          Pagination: PatchedPagination,
          OverlayLoading: () => "",
          Toolbar: (props) =>
            toolBarComponent ? (
              <div className="flex flex-row w-full ">
                {toolBarComponent}
                <div className="w-full">
                  {showToolBar ? <MTableToolbar {...props} /> : ""}
                </div>
              </div>
            ) : (
              <div>
                <MTableToolbar {...props} />
              </div>
            ),
        }}
      />
    </div>
  );
};

export default MaterialSubTable;
